const routes = [
    { path: "/login", component: () => import("../pages/Login.vue") },
    {
        path: "/",
        name: "Home",
        redirect: '/index',
    },
    {
        path: "/",
        name: "layout",
        meta: {
            title: '首页',
        },
        component: () => import("../pages/layout/BaseLayout.vue"),
        children: [
            {
                path: '/index',
                name: "dashboard",
                meta: {
                    title: '工作台',
                },
                component: () => import("../pages/dashboard/Dashboard.vue"),

            },
            {
                path: '/perf',
                name: "perf",
                meta: {
                    title: '性能测试',
                },
                children: [
                    {
                        path: '/perf/mqtt',
                        meta: {
                            title: 'MQTT压测',
                        },
                        component: () => import("../pages/perf/MqttPerf.vue")
                    },
                    {
                        path: '/perf/info',
                        name:'mqtt_info',
                        meta: {
                            title: '压测详情',
                        },
                        component: () => import("../pages/perf/MqttPerfInfo.vue"),
                    },
                    {
                        path: '/perf/http',
                        meta: {
                            title: 'HTTP压测',
                        },
                        component: () => import("../pages/perf/HttpPerf.vue"),
                    },
                ],
            },
            {
                path: '/datawork',
                name: "datawork",
                meta: {
                    title: '造数工厂',
                },
                children: [
                    {
                        path: '/datawork/list',
                        meta: {
                            title: '场景列表',
                        },
                        component: () => import("../pages/datawork/DataworkList.vue"),
                    },
                    {
                        path: '/datawork/templates',
                        meta: {
                            title: '模版管理',
                        },
                        component: () => import("../pages/datawork/TemplatesManage.vue"),
                    },
                    {
                        path: '/datawork/records',
                        meta: {
                            title: '调用历史',
                        },
                        component: () => import("../pages/datawork/Records.vue"),
                    },
                ],
            },
            {
                path: '/metersphere',
                name: "metersphere",
                meta: {
                    title: '接口自动化测试',
                },
                children: [
                    {
                        path: '/metersphere/testPlan',
                        meta: {
                            title: '接口自动化巡检',
                        },
                        component: () => import("../pages/metersphere/TestPlan.vue"),
                    },
                    {
                        path: '/metersphere/report',
                        meta: {
                            title: '巡检测试报告',
                        },
                        component: () => import("../pages/metersphere/TestReport.vue"),
                    },
                    {
                        path: '/metersphere/automation',
                        meta: {
                            title: '接口场景化测试',
                        },
                        component: () => import("../pages/metersphere/Automation.vue"),
                    },
                    {
                        path: '/autotest/testcase',
                        meta: {
                            title: 'UI用例',
                        },
                        component: () => import("../pages/autotest/TestCase.vue"),
                    },
                    {
                        path: '/autotest/testgroup',
                        meta: {
                            title: 'UI用例集',
                        },
                        component: () => import("../pages/autotest/TestGroup.vue"),
                    },
                    {
                        path: '/autotest/caseinfo',
                        name:'case_info',
                        meta: {
                            title: 'UI用例详情',
                        },
                        component: () => import("../pages/autotest/CaseInfo.vue"),
                    },
                    {
                        path: '/autotest/caseresult',
                        name:'case_result_info',
                        meta: {
                            title: 'UI用例结果',
                        },
                        component: () => import("../pages/autotest/CaseResultInfo.vue"),
                    },
                    {
                        path: '/autotest/groupinfo',
                        name:'groupinfo',
                        meta: {
                            title: 'UI用例集详情',
                        },
                        component: () => import("../pages/autotest/GroupInfo.vue"),
                    },
                    {
                        path: '/autotest/groupresult',
                        name:'groupresult',
                        meta: {
                            title: 'UI用例集执行结果详情',
                        },
                        component: () => import("../pages/autotest/GroupResultInfo.vue"),
                    },
                    
                   
                ],
            },
            {
                path: '/playwright',
                name: "playwright",
                meta: {
                    title: 'UI自动化测试',
                },
                children: [
                    {
                        path: '/playwright/webui',
                        meta: {
                            title: 'WebUI自动化测试',
                        },
                        component: () => import("../pages/playwright/WebUiTest.vue"),
                    },
                ],
            },
            {
                path: '/trans',
                meta: {
                    title: '智能翻译评测',
                },
                name: "trans",
                children: [
                    {
                        path: '/trans/dataset',
                        meta: {
                            title: '语料库管理',
                        },
                        component: () => import("../pages/trans/Dataset.vue"),
                    },
                    {
                        path: '/trans/task',
                        meta: {
                            title: '评测任务',
                        },
                        component: () => import("../pages/trans/Task.vue"),
                    },
                    {
                        path: '/trans/report',
                        name:'trans_report',
                        meta: {
                            title: '评测任务',
                        },
                        component: () => import("../pages/trans/Report.vue"),
                    },
                ],
            },
            {
                path: '/statistic',
                meta: {
                    title: '质量大盘',
                },
                name: "statistic",
                children: [
                    {
                        path: '/statistic/score',
                        meta: {
                            title: '质量大盘',
                        },
                        component: () => import("../pages/statistic/Score.vue"),
                    }
                ],
            },
        ]
    },



    {
        name: "404",
        path: "/404",
        component: () => import("../pages/NotFoundComponent.vue")
    },

]

export default routes;
